// extracted by mini-css-extract-plugin
module.exports = {"search":"CustomSelectSearch_search__Ou6Fj"};